import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';
import { from } from 'rxjs';
import { DriveServiceProvider } from '../drive-service/drive-service';
import { StoreWrapProvider } from '../store-wrap/store-wrap';
import { LoadingController } from 'ionic-angular';

const OBJLENG = 0;
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

constructor(public storeWrap: StoreWrapProvider,private loadingController: LoadingController, public driveService: DriveServiceProvider, private datePipe: DatePipe) {
  }
  currentTemplateProperty: any;
  currentFolderProperty: any;
  templateProps: any = {};
  loader: any;
  generateExcel(f_withFile) {
    var currentFolder = this.driveService.getCurrentFolder();
    var newFolder = this.driveService.getFolderStructure();
    var createdFolder = Object.assign({}, newFolder, this.driveService.objCurrentFolder);
    createdFolder.template = [];

    if (Object.keys(this.driveService.formGridTempProps).length == OBJLENG) {
      currentFolder.template.forEach((template, index) => {
        this.templateProps = this.driveService.clone(this.driveService.storeWrap.storeTemplates[template.id]);
        if (this.templateProps.pluginData == '') {
          this.templateProps.pluginData = '{}'
        }
        let plugin: any = {};
        let objTempData: any;
        plugin = eval('(' + this.templateProps.pluginData + ')');
        if (plugin == undefined || Object.keys(plugin).length != OBJLENG && plugin.hasOwnProperty("header") == false) {
          if (plugin.hasOwnProperty("exportTemp")) {
            currentFolder.template[0] = this.driveService.storeWrap.storeTemplates[plugin.exportTemp];
            objTempData = this.driveService.clone(this.driveService.storeWrap.storeTemplates[plugin.exportTemp]);
          } else {
            currentFolder.template[index] = this.driveService.storeWrap.storeTemplates[template.id];
            objTempData = this.driveService.clone(this.driveService.storeWrap.storeTemplates[template.id]);
          }
        } else {
          objTempData = this.driveService.clone(this.driveService.storeWrap.storeTemplates[template.id]);
          currentFolder.template[index] = objTempData;
        }
        createdFolder.template.push(objTempData);
      });
    } else {
      currentFolder.template = [];
      createdFolder.template.push(this.driveService.formGridTempProps['screenProps']);
      currentFolder.template.push(this.driveService.formGridTempProps['screenProps']);
    }
    var summaryData = [];
    const ObjLen = 0;

    if(f_withFile){
      summaryData = this.driveService.objCurrentFolder.files['length'] > ObjLen ? this.driveService.objCurrentFolder.files[0] : summaryData;
    }

    const title = 'folderJson';
    const header = [];
    let data = [];
    let rowItem = [];

    if (summaryData.length > 0) {
      Object.keys(summaryData[0]).forEach((key) => {
        if (key != 'RowNumber') {
          if (currentFolder.template.length > 1) {
            this.templateProps = this.templateProps != undefined || Object.keys(this.templateProps).length != 0 ? this.currentTemplateProperty : currentFolder.template[0];
            let pluginData: any = {};
            pluginData = eval('(' + this.templateProps.pluginData + ')');
            if (pluginData == undefined || pluginData) {
              if (key == this.templateProps.sourceKey) {
                header.push(key)
              } else if (this.templateProps.formLayout[0][0].fields.find(item => item.FieldName == key) && this.templateProps.formLayout[0][0].fields.find(item => item.FieldName == key).IsForm != "0" && this.templateProps.formLayout[0][0].fields.find(item => item.FieldName == key).IsForm != "NO") {
                header.push(key);
              }
              return;
            }
            // });
          } else {
            if (key == this.templateProps.sourceKey) {
              header.push(key)
            } else if (currentFolder.template[0].formLayout[0][0].fields.find(item => item.FieldName == key).IsForm != "0" && currentFolder.template[0].formLayout[0][0].fields.find(item => item.FieldName == key).IsForm != "NO") {
              header.push(key);
            }
          }
        }
      });

      Object.keys(summaryData).forEach((index) => {
        var idx = 0;
        rowItem = [];
        Object.keys(summaryData[index]).forEach((dataKey) => {
          if (dataKey != 'RowNumber') {
            if (currentFolder.template.length > 1) {
              this.templateProps = this.templateProps != undefined || Object.keys(this.templateProps).length != 0 ? this.currentTemplateProperty : currentFolder.template[0];
              let pluginData: any = {};
              pluginData = eval('(' + this.templateProps.pluginData + ')');
              if (dataKey == this.templateProps.sourceKey) {
                rowItem[idx] = summaryData[index][dataKey];
                idx++;
              } else if (this.templateProps.formLayout[0][0].fields.find(item => item.FieldName == dataKey).IsForm != "0" && this.templateProps.formLayout[0][0].fields.find(item => item.FieldName == dataKey).IsForm != "NO") {
                rowItem[idx] = summaryData[index][dataKey];
                idx++;
              }
              return;
            } else {
              if (dataKey == this.templateProps.sourceKey) {
                rowItem[idx] = summaryData[index][dataKey];
                idx++;
              } else if (currentFolder.template[0].formLayout[0][0].fields.find(item => item.FieldName == dataKey).IsForm != "0" && currentFolder.template[0].formLayout[0][0].fields.find(item => item.FieldName == dataKey).IsForm != "NO") {
                rowItem[idx] = summaryData[index][dataKey];
                idx++;
              }
            }

          }
        })
        data.push(rowItem);
      });
    } else {
      currentFolder.template.forEach(element => {
        if (element.pluginData == '') {
          element.pluginData = '{}'
        }
        if (element.sourceKey == this.currentTemplateProperty.sourceKey)
          if (element.hasOwnProperty('pluginData')) {
            var pluginData = eval('(' + element.pluginData + ')');
            if (pluginData.hasOwnProperty('header') == false) {
              for (var rowIdx = 0; rowIdx < element.formLayout.length; rowIdx++) {
                for (var colIdx = 0; colIdx < element.formLayout[rowIdx].length; colIdx++) {
                  summaryData = element.formLayout[rowIdx][colIdx]['fields'];
                }
              }
            }
          } else {
            for (var rowIdx = 0; rowIdx < element.formLayout.length; rowIdx++) {
              for (var colIdx = 0; colIdx < element.formLayout[rowIdx].length; colIdx++) {
                summaryData = element.formLayout[rowIdx][colIdx]['fields'];
              }
            }
          }
      });

      summaryData.sort(function (currField, nextField) {
        return currField.SortIdx - nextField.SortIdx;
      });

      summaryData.forEach(item => {
        if (item.FieldName == this.templateProps.sourceKey || item.IsForm != "0") {
          header.push(item.FieldName);
        }
      })
    }

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(currentFolder.name);

    //remove unwanted Folder Json Files
    createdFolder.template.forEach((item, idx) => {
      delete createdFolder["template"][idx]["filterParams"]
      delete createdFolder["template"][idx]["formLayout"];
      delete createdFolder["template"][idx]["colprops"]
    })
    if (createdFolder["files"]) {
      delete createdFolder["files"];
      createdFolder["folders"] = [];
    }

    //Add Row and formatting
    let titleRow = worksheet.addRow([title, createdFolder]);
    titleRow.font = { bold: true }
    worksheet.getCell('B1').style.font = { bold: false }

    //Add Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true }

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
    })

    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });
    this.presentLoading();
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, currentFolder.name + '.xlsx');
    })
    this.loader.dismiss();
    this.resetTemplateFields()
  }

  resetTemplateFields() {
    if (typeof this.currentFolderProperty == 'string') {
      this.driveService.objCurrentFolder = JSON.parse(this.currentFolderProperty);
    } if (typeof this.currentTemplateProperty == 'string') {
      this.currentTemplateProperty = JSON.parse(this.currentTemplateProperty);
    }
    let rootFolders = this.driveService.objRootFolder['folders']
    let Folderindex = rootFolders.findIndex(obj => obj.folder_id == this.driveService.objCurrentFolder.folder_id)
    this.driveService.objRootFolder['folders'][Folderindex] = Object.assign({}, rootFolders[Folderindex], this.driveService.objCurrentFolder)
    let storeTemplate = this.driveService.storeWrap.storeTemplates;
    this.storeWrap.storeTemplates[this.currentTemplateProperty.id] = Object.assign({}, storeTemplate[this.currentTemplateProperty.id], this.currentTemplateProperty)
  }

  presentLoading(){
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Processing Please wait...'
    });
    this.loader.present();
  }
}


// WEBPACK FOOTER //
// ./src/providers/excel-service/excel-service.ts